import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoLongText16 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M7.25488 10.38C7.60006 10.38 7.87988 10.6598 7.87988 11.005C7.87988 11.3502 7.60006 11.63 7.25488 11.63H1.75488C1.4097 11.63 1.12988 11.3502 1.12988 11.005C1.12988 10.6598 1.4097 10.38 1.75488 10.38H7.25488ZM14.2549 7.38C14.6001 7.38 14.8799 7.65983 14.8799 8.005C14.8799 8.35018 14.6001 8.63 14.2549 8.63H1.75488C1.4097 8.63 1.12988 8.35018 1.12988 8.005C1.12988 7.65983 1.4097 7.38 1.75488 7.38H14.2549ZM14.2549 4.38C14.6001 4.38 14.8799 4.65983 14.8799 5.005C14.8799 5.35018 14.6001 5.63 14.2549 5.63H1.75488C1.4097 5.63 1.12988 5.35018 1.12988 5.005C1.12988 4.65983 1.4097 4.38 1.75488 4.38H14.2549Z" fill={iconColor} />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoLongText16;